import React from 'react';
import { Compass } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { useProductTour } from '../../context/ProductTourContext';

export default function WelcomeTourModal() {
  const { phase, takeTour, skipTour } = useProductTour();

  return (
    <Modal
      isOpen={phase === 'welcome'}
      onClose={skipTour}
      title="Take a quick tour?"
      maxWidthClass="max-w-md"
    >
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-eddp-primary/10 text-eddp-primary flex items-center justify-center shrink-0">
          <Compass size={20} />
        </div>
        <p className="text-sm text-slate-600 leading-relaxed">
          A short, optional walkthrough of Dashboard, Overview, Map, Disclosure,
          Actions, Reports, Setup, and the glossary. You can skip it and explore
          on your own. After that it lives in Help and your account menu if you
          want it again.
        </p>
      </div>
      <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end mt-2">
        <Button type="button" variant="secondary" onClick={skipTour}>
          Get started
        </Button>
        <Button type="button" variant="primary" onClick={takeTour}>
          Take a tour
        </Button>
      </div>
    </Modal>
  );
}
